var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadaria({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.871 18.759C33.871 21.9024 26.5095 22.6601 17.4355 22.6601C8.36149 22.6601 1 21.8975 1 18.759C1 15.6204 8.36149 9.35794 17.4355 9.35794C26.5095 9.35794 33.871 15.6155 33.871 18.759Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04695 11.1375C9.04695 11.1375 8.22513 15.4347 9.74566 15.7084C11.2662 15.9822 11.3646 14.408 11.3646 14.408C11.3646 14.408 12.2701 10.7366 12.6293 9.93481",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2942 9.39194C16.2942 9.39194 13.8535 15.6349 15.4134 16.4562C15.5413 16.5246 15.684 16.5392 15.8267 16.5246C16.1614 16.4904 16.8453 16.2997 17.1553 15.3659C17.8787 13.1758 19.4583 9.97368 19.8421 9.49947",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8295 10.0864C22.8295 10.0864 19.567 15.8355 21.5648 16.6568C21.5648 16.6568 22.5539 17.1212 23.1739 16.0066C23.794 14.8969 25.5654 11.5237 26.1067 11.2597",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04515 11.1424L9.06479 11.1327C10.172 10.6536 11.3629 10.2429 12.6177 9.93977H12.6275C13.7987 9.65622 15.0288 9.46557 16.2935 9.39224H16.3328C16.697 9.36779 17.066 9.35315 17.44 9.35315C18.252 9.35315 19.0443 9.40689 19.8217 9.49977H19.8414C20.8698 9.62688 21.8688 9.82735 22.8284 10.0865L22.8628 10.0962C23.9995 10.4042 25.0772 10.8002 26.0859 11.25L26.1056 11.2598C26.4205 11.4015 26.7305 11.553 27.0307 11.7046C31.6267 9.48511 34.4808 7.29007 33.7033 5.2808C32.5716 2.34756 23.4483 -0.88383 14.9698 2.34273C7.77554 5.08042 3.3616 11.5873 2.88428 15.2881C4.30147 13.7921 6.44204 12.2668 9.04515 11.1327V11.1424Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2692 1.1105C20.2692 1.1105 19.2949 7.63694 21.4551 7.6956C21.4551 7.6956 22.5426 7.77381 22.7247 6.5174C22.9067 5.261 23.3447 1.48204 23.7532 1.04205",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54758 10.9278C10.0298 10.7323 10.5219 10.5514 11.0336 10.3852C11.3141 9.8621 11.1173 9.22167 11.1173 9.22167C11.1173 9.22167 10.64 5.47204 10.6843 4.59695L7.77112 6.99238C7.77112 6.99238 8.37151 10.307 9.54266 10.9278H9.54758Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2023 9.48462C15.5861 9.44062 15.9749 9.40636 16.3686 9.3868C16.6343 9.14726 16.9049 8.74151 16.8705 8.05709C16.7573 5.7545 17.0771 2.20037 17.269 1.6235L13.918 2.77724C13.918 2.77724 13.8934 8.31132 15.2073 9.47972L15.2023 9.48462Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadaria);
export default __webpack_public_path__ + "static/media/padaria.d69aee9375372389a8acf42ae21cda51.svg";
export { ForwardRef as ReactComponent };